import { render, staticRenderFns } from "./PreviewTitle.vue?vue&type=template&id=78389dcc"
import script from "./PreviewTitle.vue?vue&type=script&lang=js"
export * from "./PreviewTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78389dcc')) {
      api.createRecord('78389dcc', component.options)
    } else {
      api.reload('78389dcc', component.options)
    }
    module.hot.accept("./PreviewTitle.vue?vue&type=template&id=78389dcc", function () {
      api.rerender('78389dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/PreviewTitle.vue"
export default component.exports